import { FunctionsHttpError } from '@supabase/supabase-js';

// Separado de lead-intake.ts para poder probarlo en node sin levantar el cliente
// de Supabase (scripts/autoClienteHarness).

/**
 * ¿Se puede repetir el pedido por fetch después de que falló el SDK?
 *
 * Sólo si el pedido NUNCA llegó a la función (red, relay). Si la función
 * RESPONDIÓ —aunque sea con 4xx/5xx, o un 504 del gateway después de insertar—
 * pudo haber escrito: Compra Directa y Consignación crean el lead en esta misma
 * llamada (ticket #96), y repetirla duplicaba el lead.
 */
export function sePuedeReintentar(err: unknown): boolean {
  return !(err instanceof FunctionsHttpError);
}

/** El `error` que devolvió la función, si respondió con JSON. */
export async function errorDeLaFuncion(err: unknown): Promise<string> {
  try {
    const data = await ((err as FunctionsHttpError).context as Response).json();
    if (typeof data?.error === 'string') return data.error;
  } catch {
    // cuerpo vacío o no JSON: cae al mensaje genérico
  }
  return 'Error en public-lead-intake';
}
